import { MonthYearFormatter } from '../formatters/MonthYearFormatter';
import { DateFormatter } from '../formatters/DateFormatter';

/**
 * Los formatter son de tipo "Formatter" de "redux-form" y se pasan en el prop "format" del componente "Field".
 * Los parser son de tipo "Parser" de "redux-form" y se pasan en el prop "parse" del componente "Field".
 * Los normalizer son de tipo "Normalizer" de "redux-form" y se pasan en el prop "normalize" del componente "Field".
 *
 * ORDEN DE LLAMADA: https://redux-form.com/7.4.2/docs/valuelifecycle.md/
 */

const checkStringValue = (value) => typeof value === 'string';

export class ReduxFormUtils {

    static selectFormValues = (state, formName) => {
        return state.form[formName]
            ? state.form[formName].values
                ? state.form[formName].values
                : {}
            : {};
    };

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    static monthYearFormatter = (value) => {
        return checkStringValue(value)
            ? MonthYearFormatter.format(value)
            : null;
    };

    static  monthYearParser = (value) => {
        return checkStringValue(value)
            ? MonthYearFormatter.deformat(value)
            : null;
    };

    static monthYearNormalizer = (value, previousValue) => {
        return checkStringValue(value) && MonthYearFormatter.isValidInput(value)
            ? value
            : previousValue || null;
    };

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    static dateFormatter = (value) => {
        return checkStringValue(value)
            ? DateFormatter.format(value)
            : null;
    };

    static dateParser = (value) => {
        return checkStringValue(value)
            ? DateFormatter.deformat(value)
            : null;
    };

    static dateNormalizer = (value, previousValue) => {
        return checkStringValue(value) && DateFormatter.isValidInput(value)
            ? value
            : previousValue || null;
    };

}



// WEBPACK FOOTER //
// ./src/app/shared/utils/ReduxFormUtils.js